module.exports = __webpack_public_path__ + "static/media/status-error-white.9c21f1f9.svg";